import { type ReactNode, useState } from 'react';

import { NofomoStoreContext } from './context';
import {
  createNofomoStore,
  initNofomoStore,
  type NofomoStoreReturnType,
} from './zustand';

interface NofomoStoreProviderProps {
  children: ReactNode;
}

export const NofomoStoreProvider = ({ children }: NofomoStoreProviderProps) => {
  const [store] = useState<NofomoStoreReturnType>(() =>
    createNofomoStore(initNofomoStore()),
  );

  return (
    <NofomoStoreContext.Provider value={store}>
      {children}
    </NofomoStoreContext.Provider>
  );
};
